"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolItem$ = exports.SchoolItem$outboundSchema = exports.SchoolItem$inboundSchema = void 0;
exports.schoolItemToJSON = schoolItemToJSON;
exports.schoolItemFromJSON = schoolItemFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const geopointlocation_js_1 = require("./geopointlocation.js");
const schooltypes_js_1 = require("./schooltypes.js");
/** @internal */
exports.SchoolItem$inboundSchema = z.object({
    distance_in_metres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$inboundSchema,
    name: z.string(),
    postcode: z.string(),
    school_rating: z.nullable(z.string()),
    school_types: z.array(schooltypes_js_1.SchoolTypes$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "distance_in_metres": "distanceInMetres",
        "school_rating": "schoolRating",
        "school_types": "schoolTypes",
    });
});
/** @internal */
exports.SchoolItem$outboundSchema = z.object({
    distanceInMetres: z.nullable(z.number().int()),
    location: geopointlocation_js_1.GeoPointLocation$outboundSchema,
    name: z.string(),
    postcode: z.string(),
    schoolRating: z.nullable(z.string()),
    schoolTypes: z.array(schooltypes_js_1.SchoolTypes$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        distanceInMetres: "distance_in_metres",
        schoolRating: "school_rating",
        schoolTypes: "school_types",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SchoolItem$;
(function (SchoolItem$) {
    /** @deprecated use `SchoolItem$inboundSchema` instead. */
    SchoolItem$.inboundSchema = exports.SchoolItem$inboundSchema;
    /** @deprecated use `SchoolItem$outboundSchema` instead. */
    SchoolItem$.outboundSchema = exports.SchoolItem$outboundSchema;
})(SchoolItem$ || (exports.SchoolItem$ = SchoolItem$ = {}));
function schoolItemToJSON(schoolItem) {
    return JSON.stringify(exports.SchoolItem$outboundSchema.parse(schoolItem));
}
function schoolItemFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SchoolItem$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SchoolItem' from JSON`);
}
//# sourceMappingURL=schoolitem.js.map